import { checkCreatedTreeObject, useAppDispatch } from '@core/core/store'
import type { ChannelMessage } from 'common/messenger'
import { messengerRef } from 'common/messenger'
import type { ProjectId } from 'common/types'
import { useEffect } from 'react'

export const useMessenger = (projectId: ProjectId) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    function handler(e: ChannelMessage<'horizonCreated'>) {
      if (projectId !== '') {
        dispatch(checkCreatedTreeObject(projectId, e.payload, 'horizon'))
      }
    }

    const unsubscribe = messengerRef.current?.subscribe('horizonCreated', handler)

    return unsubscribe
  }, [projectId])

  useEffect(() => {
    function handler(e: ChannelMessage<'faultCreated'>) {
      if (projectId !== '') {
        dispatch(checkCreatedTreeObject(projectId, e.payload, 'fault'))
      }
    }

    const unsubscribe = messengerRef.current?.subscribe('faultCreated', handler)

    return unsubscribe
  }, [projectId])

  useEffect(() => {
    function handler(e: ChannelMessage<'interpretation3DCreated'>) {
      if (projectId !== '') {
        dispatch(checkCreatedTreeObject(projectId, e.payload, 'interpretation3D'))
      }
    }

    const unsubscribe = messengerRef.current?.subscribe('interpretation3DCreated', handler)

    return unsubscribe
  }, [projectId])

  useEffect(() => {
    function handler(e: ChannelMessage<'interpretation2DCreated'>) {
      if (projectId !== '') {
        dispatch(checkCreatedTreeObject(projectId, e.payload, 'interpretation2D'))
      }
    }

    const unsubscribe = messengerRef.current?.subscribe('interpretation2DCreated', handler)

    return unsubscribe
  }, [projectId])
}
